/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientBehaviorAntecedentModel } from '../../models/patient-behavior-antecedent-model';

export interface SavePatientBehaviorAntecedent$Params {
      body?: PatientBehaviorAntecedentModel
}

export function SavePatientBehaviorAntecedent(http: HttpClient, rootUrl: string, params?: SavePatientBehaviorAntecedent$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientBehaviorAntecedentModel>> {
  const rb = new RequestBuilder(rootUrl, SavePatientBehaviorAntecedent.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PatientBehaviorAntecedentModel>;
    })
  );
}

SavePatientBehaviorAntecedent.PATH = '/api/Staff/SavePatientBehaviorAntecedent';
